module.exports = __webpack_public_path__ + "img/sort_icon.a53c90ee.svg";